import React from "react";
import { companyInfo } from "../data/mock";
import { Separator } from "./ui/separator";
import { Recycle, Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
      "Bulk Scrap Purchase",
      "Industrial Scrap Pickup",
      "E-Waste Management",
      "Office Scrap Disposal",
      "Machinery Scrap",
    ],
    Company: [
      { label: "About Us", href: "#about" },
      { label: "Why Choose Us", href: "#why-choose" },
      { label: "Compliance", href: "#compliance" },
      { label: "Testimonials", href: "#testimonials" },
      { label: "Contact", href: "#contact" },
    ],
    Policies: [
      "Privacy Policy",
      "Terms of Service",
      "Refund Policy",
      "Cookie Policy",
    ],
  };

  const handleNavClick = (href) => {
    if (href && href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-10 h-10 rounded-xl bg-emerald-700 flex items-center justify-center">
                <Recycle className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="text-lg font-bold">{companyInfo.name}</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-400 font-medium">
                  Authorized Dealer
                </div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Chennai's most trusted government-authorized scrap dealer. We help industries
              and corporates safely sell scrap with transparent pricing and instant payment.
            </p>
            <div className="space-y-3">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2.5 text-slate-400 hover:text-emerald-400 transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {companyInfo.phone}
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2.5 text-slate-400 hover:text-emerald-400 transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                {companyInfo.email}
              </a>
              <div className="flex items-start gap-2.5 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                {companyInfo.address}
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link, i) => {
                  const isObj = typeof link === "object";
                  return (
                    <li key={i}>
                      <button
                        onClick={() =>
                          isObj
                            ? handleNavClick(link.href)
                            : null
                        }
                        className="text-slate-400 hover:text-emerald-400 transition-colors text-sm text-left"
                      >
                        {isObj ? link.label : link}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="my-10 bg-slate-800" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Government Authorized Scrap Dealer | Chennai, Tamil Nadu
          </p>
        </div>
      </div>
    </footer>
  );
};
